import React from "react";
import styled from "styled-components";
import Box from "../../../elements/v2/Box/Box";
import { breakpoints } from "../../../../utils/styledHelpers";
import { useSearchPageContext } from "../SearchPageContext";
import { BUTTON_SIZES, OutlineButton } from "../../../elements/v2/Button/Button";
import SearchSort from "../../../../utils/algolia/SearchSort";
import FlexBox from "../../../elements/v2/Box/FlexBox";

export default function MobileSearchHeader() {
  const { setMobileSidebarOpen } = useSearchPageContext();

  function toggleOpen() {
    setMobileSidebarOpen((o) => !o);
  }

  return (
    <MobileOnly flexDirection="row" display="flex">
      <FlexBox p={0.5} width="100%">
        <FilterButton onClick={toggleOpen}>Filter</FilterButton>
        <SearchSort />
      </FlexBox>
    </MobileOnly>
  );
}

const FilterButton = styled(OutlineButton).attrs({
  size: BUTTON_SIZES.MEDIUM,
})`
  width: 100%;
  text-transform: capitalize;
`;

const MobileOnly = styled(Box)`
  flex-direction: row;
  display: flex;

  ${breakpoints.up("tablet")} {
    display: none;
  }
`;
